import { Component, OnInit, EventEmitter, Output, Inject, ViewChild, TemplateRef, HostListener } from "@angular/core";
import { DatePipe, DOCUMENT } from "@angular/common";
import { EventService } from "../../core/services/event.service";

// Language
import { CookieService } from "ngx-cookie-service";
import { Language, LanguageService } from "../../core/services/language.service";
import { NgbModal, NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "src/app/shared/services/auth.service";
import { Helper } from "src/app/core/helpers/helper";
import { environment } from "src/environments/environment";
import { RootReducerState } from "src/app/store";
import { Store } from "@ngrx/store";
import { changeMode } from "src/app/store/layouts/layout-action";
import { LocationModel, LocationService } from "src/app/shared/services/location.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { BookingType } from "src/app/core/constants/bookingConstant";
import { debounceTime, distinctUntilChanged, filter, Observable, of, Subject, Subscription, switchMap } from "rxjs";
import { EDeliveryService } from "src/app/pages/users/e-delivery/services/e-delivery.service";
import { QCommerceService } from "src/app/pages/users/q-commerce/services/q-commerce.service";
import { ServicesService } from "src/app/pages/users/service/services/services.service";
import { MainCategory } from "src/app/pages/users/q-commerce/models/main-category.model";
import { GoogleMapsService } from "src/app/shared/services/google-map.service";
import { MapBoxService } from "src/app/shared/services/mapbox.service";
import { DateTimePickerModalComponent } from "src/app/shared/modal-components/date-time-picker-modal/date-time-picker-modal.component";
import { ServiceProviderModalComponent } from "src/app/pages/users/service/components/service-provider-modal/service-provider-modal.component";
import { CartModalComponent } from "src/app/pages/users/e-delivery/components/cart-modal/cart-modal.component";
import { NavigationEnd, Router } from "@angular/router";
import { AddressModalComponent } from "src/app/shared/modal-components/address-modal/address-modal.component";
import { Cart } from "src/app/pages/users/q-commerce/models/cart.model";

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.scss"],
  standalone: false
})
export class TopbarComponent implements OnInit {
  messages: any;
  element: any;
  mode: string | undefined;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  allnotifications: any;
  flagvalue: any;
  valueset: any;

  userData: any;
  total = 0;
  totalNotify: number = 0;
  newNotify: number = 0;
  readNotify: number = 0;
  isDropdownOpen = false;
  notifyId: any;
  partnerDetails: any = [];
  bookingTime!: any;
  userName: string = "";
  currentLanguage!: string;
  languages!: Language[];
  selectedBookingType!: any;
  deliveryAddressForm!: FormGroup;
  selectedSearchIndex: number = -1;
  destinationPredictions: Array<any> = [];
  selectedSearchAddress!: string;
  citySettings: any;
  totalCartItems: number = 0;
  autocompleteElement: any;
  currentDeliveryAddress!: LocationModel;
  entityType!: number;
  typeId!: string;
  private inputSubject: Subject<any> = new Subject<any>();
  private inputSubscription!: Subscription;
  @ViewChild("removenotification") removenotification!: TemplateRef<any>;
  @ViewChild("dateTimePickerModal", { static: true }) dateTimePickerModal!: DateTimePickerModalComponent;
  @ViewChild("cartModal", { static: true }) cartModal!: CartModalComponent;
  @ViewChild("serviceProviderModal", { static: true }) serviceProviderModal!: ServiceProviderModalComponent;
  @ViewChild("addressModal") addressModal!: AddressModalComponent;

  // eslint-disable-next-line max-params
  constructor(
    @Inject(DOCUMENT) private document: any,
    private eventService: EventService,
    public languageService: LanguageService,
    private modalService: NgbModal,
    public _cookiesService: CookieService,
    private authService: AuthService,
    private edeliveryService: EDeliveryService,
    private qcommerceService: QCommerceService,
    private servicesService: ServicesService,
    private googleMapService: GoogleMapsService,
    private mapBoxService: MapBoxService,
    private formBuilder: FormBuilder,
    private locationService: LocationService,
    public helper: Helper,
    private datePipe: DatePipe,
    private store: Store<RootReducerState>,
    private router: Router,
    private offcanvasService: NgbOffcanvas
  ) {
    this.languages = this.languageService.supportedLanguages;
    this.currentLanguage = localStorage.getItem("theme_lang") ?? environment.defaultLang;
  }

  /**
   * Handles keyboard events for navigating through address predictions.
   * @param event The keyboard event.
   */
  @HostListener("document:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent): void {
    const mapType = this.helper.adminSettings?.mapType;

    if (mapType === this.helper.MapType.GOOGLE && this.destinationPredictions.length > 0) {
      if (event.key === "ArrowDown") {
        this.selectedSearchIndex = (this.selectedSearchIndex + 1) % this.destinationPredictions.length;
      } else if (event.key === "ArrowUp") {
        this.selectedSearchIndex = (this.selectedSearchIndex - 1 + this.destinationPredictions.length) % this.destinationPredictions.length;
      } else if (event.key === "Enter" && this.selectedSearchIndex >= 0 && this.selectedSearchIndex < this.destinationPredictions.length) {
        this.onPredictionSelect(this.destinationPredictions[this.selectedSearchIndex]);
        this.selectedSearchIndex = -1;
      }
    }
  }

  ngOnInit(): void {
    this.setCurrentLocation();
    this.initializeDeliveryAddressForm();
    if (this.helper.mapTypeGoogle()) {
      this.addressAutoComplete();
    } else if (this.helper.mapTypeMapBox()) {
      this.addressAutoCompleteMapbox();
    }
    this.bookingTime = 0;
    localStorage.removeItem("bookingTime");
    if (this.helper.route.url.includes("/users/create-booking/e-delivery")) {
      this.edeliveryService.merchantSettingSubject$.subscribe((merchantSetting) => {
        if (merchantSetting && merchantSetting.deliveryScheduleSetting) {
          if (!merchantSetting.deliveryScheduleSetting.isActive) {
            this.bookingTime = 0;
            localStorage.removeItem("bookingTime");
          } else {
            if (this.bookingTime) {
              // Convert bookingTime to Date if it's stored as a timestamp or string
              const bufferTime = new Date(new Date().getTime() + merchantSetting.deliveryScheduleSetting.userScheduleBuffer * 60000);
              const bookingTimeDate = new Date(this.bookingTime);
              if (bookingTimeDate.getTime() < bufferTime.getTime()) {
                localStorage.setItem("bookingTime", new Date(bufferTime).getTime().toString());
                this.bookingTime = `${this.datePipe.transform(bufferTime, "dd MMMM yyyy")}-${this.datePipe.transform(bufferTime, "hh:mm a")}`;
              }
            }
          }
        }
      });
      this.edeliveryService.bookingType$.subscribe((bookingType) => {
        const previousBookingType = this.selectedBookingType;
        this.selectedBookingType = bookingType;
        // Reset bookingTime if the new bookingType contradicts the previous selectedBookingType
        if (previousBookingType !== this.selectedBookingType) {
          this.bookingTime = 0;
          localStorage.removeItem("bookingTime");
        }
      });
    } else if (this.helper.route.url.includes("/users/create-booking/services")) {
      this.servicesService.bookingType$.subscribe((bookingType) => {
        const previousBookingType = this.selectedBookingType;
        this.selectedBookingType = bookingType;

        // Reset bookingTime if the new bookingType contradicts the previous selectedBookingType
        if (previousBookingType !== this.selectedBookingType) {
          this.bookingTime = 0;
          localStorage.removeItem("bookingTime");
        }
      });
    }
    if (this.helper.route.url.includes("/users/create-booking/e-delivery")) {
      this.edeliveryService.cartItems$.subscribe((items) => {
        this.totalCartItems = items.length || JSON.parse(localStorage.getItem("deliveryCartItems") || "[]").length;
      });
    } else if (this.helper.route.url.includes("/users/create-booking/quick-commerce")) {
      this.qcommerceService.cartItems$.subscribe((items) => {
        this.totalCartItems = items.length || JSON.parse(localStorage.getItem("cartItems") || "[]").length;
      });
    } else if (this.helper.route.url.includes("/users/create-booking/services")) {
      this.servicesService.cartItems$.subscribe((items) => {
        this.totalCartItems = items.length || JSON.parse(localStorage.getItem("serviceCartItems") || "[]").length;
      });
    }
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        filter(
          (event: NavigationEnd) =>
            event.url.includes("/users/create-booking/e-delivery") ||
            event.url.includes("/users/create-booking/quick-commerce") ||
            event.url.includes("/users/create-booking/services")
        )
      )
      .subscribe(() => {
        this.setCurrentLocation();
        if (this.helper.route.url.includes("/users/create-booking/e-delivery")) {
          this.edeliveryService.cartItems$.subscribe((items) => {
            this.totalCartItems = items.length || JSON.parse(localStorage.getItem("deliveryCartItems") || "[]").length;
          });
        } else if (this.helper.route.url.includes("/users/create-booking/quick-commerce")) {
          this.qcommerceService.cartItems$.subscribe((items) => {
            this.totalCartItems = items.length || JSON.parse(localStorage.getItem("cartItems") || "[]").length;
          });
        } else if (this.helper.route.url.includes("/users/create-booking/services")) {
          this.servicesService.cartItems$.subscribe((items) => {
            this.totalCartItems = items.length || JSON.parse(localStorage.getItem("serviceCartItems") || "[]").length;
          });
        }
      });
    this.helper.getDetails.subscribe((res) => {
      this.userData = res.entity;
    });
    this.element = document.documentElement;
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any): void {
    document.querySelector(".hamburger-icon")?.classList.toggle("open");
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Fullscreen method
   */
  fullscreen(): void {
    document.body.classList.toggle("fullscreen-enable");
    if (!document.fullscreenElement && !this.element.mozFullScreenElement && !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
  /**
   * Open modal
   * @param content modal content
   */
  openModal(content: any): void {
    this.modalService.open(content, { centered: true });
  }

  /**
   * Topbar Light-Dark Mode Change
   */
  changeMode(mode: string): void {
    this.mode = mode;
    this.eventService.broadcast("changeMode", mode);
    this.store.dispatch(changeMode({ mode: mode }));
    this.helper.themeMode.next({});

    switch (mode) {
      case "light":
        document.documentElement.setAttribute("data-bs-theme", "light");
        break;
      case "dark":
        document.documentElement.setAttribute("data-bs-theme", "dark");
        break;
      default:
        document.documentElement.setAttribute("data-bs-theme", "light");
        break;
    }
  }

  /***
   * Language Value Set
   */
  setLanguage(lang: any): void {
    this.languageService.language = lang.code;
    this.currentLanguage = this.languageService.languageShorthand;
    window.location.reload();
  }

  /**
   * Logout the user
   */
  logout(): void {
    const json = {
      loginBy: this.helper.LoginBy.PHONE,
      countryPhoneCode: this.partnerDetails.countryPhoneCode,
      phone: this.partnerDetails.phone
    };
    this.authService.logOut(json).subscribe();
  }

  windowScroll(): void {
    // if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
    //   ;(document.getElementById("back-to-top") as HTMLElement).style.display = "block"
    //   document.getElementById("page-topbar")?.classList.add("topbar-shadow")
    // } else {
    //   ;(document.getElementById("back-to-top") as HTMLElement).style.display = "none"
    //   document.getElementById("page-topbar")?.classList.remove("topbar-shadow")
    // }
  }

  toggleDropdown(event: Event): void {
    event.stopPropagation();
    if (this.isDropdownOpen) {
      this.isDropdownOpen = false;
    } else {
      this.isDropdownOpen = true;
    }
  }

  // Remove Notification
  checkedValGet: any[] = [];
  onCheckboxChange(event: any, id: any): void {
    this.notifyId = id;
    const checkedVal: any[] = [];
    if (id === "1") {
      for (const notification of this.allnotifications) {
        if (notification.state) {
          checkedVal.push(notification.id);
        }
      }

      this.checkedValGet = checkedVal;
    } else {
      for (const message of this.messages) {
        if (message.state) {
          checkedVal.push(message.id);
        }
      }

      this.checkedValGet = checkedVal;
    }
    const notificationActionsElement = document.getElementById("notification-actions") as HTMLElement;

    notificationActionsElement.style.display = checkedVal.length > 0 ? "block" : "none";
  }

  notificationDelete(): void {
    const checkedValGet = this.checkedValGet;
    const notifications = this.notifyId === "1" ? this.allnotifications : this.messages;

    for (const item of notifications) {
      if (checkedValGet.includes(item.id)) {
        const itemIndex = notifications.indexOf(item);
        if (itemIndex !== -1) {
          notifications.splice(itemIndex, 1);
        }
      }
    }

    this.calculatenotification();
    this.modalService.dismissAll();
  }

  calculatenotification(): void {
    this.totalNotify = 0;
    this.checkedValGet = [];

    const notificationActionsElement = document.getElementById("notification-actions") as HTMLElement;

    notificationActionsElement.style.display = this.checkedValGet.length > 0 ? "block" : "none";

    if (this.totalNotify === 0) {
      document.querySelector(".empty-notification-elem")?.classList.remove("d-none");
    }
  }

  /**
   * Handel error when image is not loaded and gets error
   */
  handleImageError(event: any): void {
    event.target.src = this.helper.DefaultImages.DefaultUserImage;
  }

  /**
   * Handles input focus events.
   */
  onInputFocus(): void {
    this.destinationPredictions = [];
  }

  /**
   * Handles input change events.
   * @param event The input event.
   */
  onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value.trim();
    this.inputSubject.next({ value: inputValue, elem: inputElement.id });
  }

  /**
   * Opens the date-time picker modal.
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity, complexity
  openDateTimePickerModal(): void {
    const citySetting = JSON.parse(localStorage.getItem("citySetting") || "{}");
    let bufferTime = 0;
    let slotIntervalInMinutes = 0;
    let maxBookingDays = 0;
    let selectionType = 0;
    if (this.helper.route.url.includes("/users/create-booking/e-delivery")) {
      const merchantSetting = JSON.parse(localStorage.getItem("merchantSetting") || "{}");
      const isMerchantListPage = this.helper.route.url === "/users/create-booking/e-delivery";
      maxBookingDays = citySetting.driverSetting[this.helper.BookingType[this.selectedBookingType]][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.maxBookingDays;
      selectionType =
        citySetting.driverSetting[this.helper.BookingType[this.selectedBookingType]][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.scheduleTimeSelectionType;
      bufferTime =
        merchantSetting && merchantSetting.deliveryScheduleSetting?.isActive && !isMerchantListPage
          ? merchantSetting.deliveryScheduleSetting.userScheduleBuffer
          : citySetting.driverSetting[this.helper.BookingType[this.selectedBookingType]][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.bufferTime;
      slotIntervalInMinutes =
        merchantSetting && merchantSetting.deliveryScheduleSetting?.isActive && !isMerchantListPage
          ? merchantSetting.deliveryScheduleSetting.deliverySlot
          : citySetting.driverSetting[this.helper.BookingType[this.selectedBookingType]][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.slotIntervalInMinutes;
    } else if (this.helper.route.url.includes("/users/create-booking/services")) {
      const merchantSetting = JSON.parse(localStorage.getItem("serviceMerchantSetting") || "{}");
      maxBookingDays = citySetting.driverSetting["ON_SITE_SERVICE"][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.maxBookingDays;
      selectionType = citySetting.driverSetting["ON_SITE_SERVICE"][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.scheduleTimeSelectionType;
      bufferTime =
        this.typeId && this.entityType && merchantSetting && merchantSetting.deliveryScheduleSetting?.isActive
          ? merchantSetting.deliveryScheduleSetting.userScheduleBuffer
          : citySetting.driverSetting["ON_SITE_SERVICE"][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.bufferTime;
      slotIntervalInMinutes =
        this.typeId && this.entityType && merchantSetting && merchantSetting.deliveryScheduleSetting?.isActive
          ? merchantSetting.deliveryScheduleSetting.deliverySlot
          : citySetting.driverSetting["ON_SITE_SERVICE"][this.helper.BookingType[this.helper.BookingType.SCHEDULE]]?.slotIntervalInMinutes;
    }
    if (this.isSchedule()) {
      this.dateTimePickerModal.openModal({
        maxBookingDays: maxBookingDays,
        bufferTime: bufferTime,
        selectionType: selectionType,
        slotIntervalInMinutes: slotIntervalInMinutes
      });
    }
  }

  isSchedule(): boolean {
    if (this.selectedBookingType && localStorage.getItem("citySetting")) {
      const citySetting = JSON.parse(localStorage.getItem("citySetting") || "{}");
      const bookingTypeKey = this.helper.BookingType[this.selectedBookingType];
      return citySetting ? citySetting.businessSetting[bookingTypeKey]?.includes(this.helper.BookingType[this.helper.BookingType.SCHEDULE].toString()) : false;
    }
    return false;
  }

  /**
   * Handles address prediction selection.
   * @param prediction The selected prediction.
   */
  async onPredictionSelect(prediction: any): Promise<void> {
    const isGoogle = this.helper.mapTypeGoogle();
    this.selectedSearchAddress = isGoogle ? prediction.description : prediction.place_name;
    this.destinationPredictions = [];
    const place = isGoogle ? await this.googleMapService.fetchFields(prediction) : await this.mapBoxService.extractMapboxPlaceDetails(prediction);
    place.placeId = isGoogle ? prediction.place_id : prediction.properties.mapbox_id;
    this.onPlaceSelected(place);
  }

  /**
   * Initializes the delivery address form with a single form control for the delivery address.
   * The delivery address form is used to input the delivery address in the header component.
   */
  initializeDeliveryAddressForm(): void {
    this.deliveryAddressForm = this.formBuilder.group({
      deliveryAddress: [""]
    });
  }

  getDescription(isGoogle: boolean, prediction: any): string {
    if (isGoogle) {
      return prediction.description;
    }
    return prediction.place_name;
  }

  /**
   * Handles place selection.
   * @param place The selected place.
   */
  onPlaceSelected(place: any): void {
    const address = this.helper.parseAddressComponents(place);
    address.address = this.selectedSearchAddress;
    this.checkBusiness(address);
    this.deliveryAddressForm.patchValue({
      deliveryAddress: this.selectedSearchAddress
    });
  }

  /**
   * Sets up address autocomplete.
   */
  addressAutoComplete(): void {
    const params = {};
    if (this.inputSubscription) {
      this.inputSubscription.unsubscribe();
    }
    const processPredictions = async (input: any): Promise<Observable<any>> => {
      this.destinationPredictions = [];
      this.autocompleteElement = input.elem;
      return await this.googleMapService.getPlacePredictions(input.value, params);
    };
    const handlePredictions = (predictions: any): void => {
      const match = this.autocompleteElement.match(/^(\D+)(\d+)$/);
      if (match) {
        const [, address] = match;
        this.autocompleteElement = address;
      }
      this.destinationPredictions = predictions;
    };
    this.inputSubscription = this.inputSubject.pipe(debounceTime(500), distinctUntilChanged(), switchMap(processPredictions)).subscribe(handlePredictions);
  }

  /**
   * Initializes address auto-completion using Mapbox based on user input.
   * Unsubscribes from existing input subscription if any, then sets up a new subscription.
   * Processes input events with a debounce to fetch predictions from Mapbox.
   * Filters and assigns predictions based on the type of address element.
   *
   * @returns {void}
   */
  addressAutoCompleteMapbox(): void {
    if (this.inputSubscription) {
      this.inputSubscription.unsubscribe();
    }

    const processPredictions = (input: any): Observable<any> => {
      this.destinationPredictions = [];
      this.autocompleteElement = input.elem;
      const query = input.value.trim();

      if (!query) {
        return of([]);
      }

      return this.mapBoxService.search(query);
    };

    const handlePredictions = (res: any): void => {
      const match = this.autocompleteElement.match(/^(\D+)(\d+)$/);
      if (match) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [fullMatch, address, num] = match;
        this.autocompleteElement = address;
      }
      this.destinationPredictions = res?.features || [];
    };

    this.inputSubscription = this.inputSubject.pipe(debounceTime(500), distinctUntilChanged(), switchMap(processPredictions)).subscribe({
      next: handlePredictions,
      error: (err) => console.error("[Mapbox] Error during autocomplete:", err),
      // eslint-disable-next-line no-console
      complete: () => console.log("[Mapbox] Autocomplete stream completed")
    });
  }

  /**
   * Sets the current location.
   */
  setCurrentLocation(): void {
    this.locationService.setCurrentLocationAsync().then((currentAddress: any) => {
      this.currentDeliveryAddress = currentAddress;
      const storedCurrentDeliveryAddress = JSON.parse(localStorage.getItem("currentDeliveryAddress") || "{}");
      if (storedCurrentDeliveryAddress?.address) {
        if (storedCurrentDeliveryAddress?.address) {
          this.checkBusiness(storedCurrentDeliveryAddress);
        }
        this.deliveryAddressForm.patchValue({
          deliveryAddress: storedCurrentDeliveryAddress.address
        });
      } else {
        if (currentAddress?.address) {
          this.checkBusiness(currentAddress);
        }
        this.deliveryAddressForm.patchValue({
          deliveryAddress: currentAddress.address
        });
      }
    });
  }

  toggleDeliveryBookingType(bookingType: BookingType): void {
    this.selectedBookingType = bookingType;
    this.bookingTime = 0;
    localStorage.removeItem("bookingTime");
    this.edeliveryService.updateBookingType(this.selectedBookingType);
  }

  toggleServiceBookingType(bookingType: BookingType): void {
    this.selectedBookingType = bookingType;
    this.bookingTime = 0;
    localStorage.removeItem("bookingTime");
    this.servicesService.updateBookingType(this.selectedBookingType);
  }

  /**
   * Checks if a business is available for ordering.
   * Checks if a business is available for ordering using the ApiService.
   * Subscribes to the service's observable to receive the response data, updates the observer with the response data and completes the observable.
   * If there is an error, it updates the observer with false and completes the observable.
   * @param currentAddress The current delivery address.
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  checkBusiness(currentAddress: any): void {
    const storedDeliveryAddress = JSON.parse(localStorage.getItem("currentDeliveryAddress") || "{}");
    const parameters: any = {
      destinationAddress: currentAddress
    };
    if (this.helper.route.url.includes("/users/create-booking/e-delivery")) {
      const merchantDetails = JSON.parse(localStorage.getItem("merchantDetails") || "{}");
      parameters["merchantId"] = merchantDetails ? merchantDetails._id : "";
      if (currentAddress.city !== storedDeliveryAddress.city) {
        localStorage.removeItem("mainCategory");
      }
      if (localStorage.getItem("mainCategory") !== "undefined") {
        const mainCategory: MainCategory = JSON.parse(localStorage.getItem("mainCategory") || "{}");
        if (mainCategory._id) {
          parameters["mainCategoryId"] = mainCategory._id;
        }
      }
    }
    if (this.helper.route.url.includes("/users/create-booking/e-delivery")) {
      this.edeliveryService.checkDeliveryBusiness(parameters).subscribe((res) => {
        if (res) {
          this.citySettings = res.citySetting;
          this.helper.currencySign = res.countrySetting.currencySign;
          localStorage.setItem("citySetting", JSON.stringify(res.citySetting));
          localStorage.setItem("countrySetting", JSON.stringify(res.countrySetting));
          this.selectedBookingType = this.helper.BookingType[res.citySetting?.businessSequence[0]];
          this.edeliveryService.updateBookingType(this.selectedBookingType);
          if (this.helper.route.url === "/users/create-booking/e-delivery/merchant-details" && currentAddress.address !== storedDeliveryAddress.address) {
            this.helper.route.navigate(["/users/create-booking/e-delivery"]);
          }
          this.edeliveryService.updateCitySetting(this.citySettings);
          localStorage.setItem("currentDeliveryAddress", JSON.stringify(currentAddress));
        } else {
          localStorage.removeItem("citySetting");
          localStorage.removeItem("countrySetting");
          this.edeliveryService.updateCitySetting(null);
          this.helper.route.navigate(["/users/create-booking"]);
        }
      });
    } else if (this.helper.route.url.includes("/users/create-booking/quick-commerce")) {
      this.qcommerceService.checkQuickCommerceBusiness(parameters).subscribe((res) => {
        if (res) {
          this.citySettings = res.citySetting;
          this.helper.currencySign = res.countrySetting.currencySign;
          localStorage.setItem("merchantId", res.merchantId);
          localStorage.setItem("citySetting", JSON.stringify(res.citySetting));
          localStorage.setItem("countrySetting", JSON.stringify(res.countrySetting));
          this.qcommerceService.updateCitySetting(this.citySettings);
          localStorage.setItem("currentDeliveryAddress", JSON.stringify(currentAddress));
        } else {
          localStorage.removeItem("citySetting");
          localStorage.removeItem("countrySetting");
          this.qcommerceService.updateCitySetting(null);
          this.helper.route.navigate(["/users/create-booking"]);
        }
      });
    } else if (this.helper.route.url.includes("/users/create-booking/services")) {
      this.servicesService.checkServiceBusiness(parameters).subscribe((res) => {
        if (res) {
          this.citySettings = res.citySetting;
          this.helper.currencySign = res.countrySetting.currencySign;
          localStorage.setItem("citySetting", JSON.stringify(res.citySetting));
          localStorage.setItem("countrySetting", JSON.stringify(res.countrySetting));
          if (this.selectedBookingType && res.citySetting.businessSequence.includes(this.helper.BookingType[this.selectedBookingType])) {
            this.servicesService.updateBookingType(this.selectedBookingType);
          } else {
            this.selectedBookingType = this.helper.BookingType[res.citySetting?.businessSequence[0]];
            this.servicesService.updateBookingType(this.selectedBookingType);
          }
          this.servicesService.updateCitySetting(this.citySettings);
          localStorage.setItem("currentDeliveryAddress", JSON.stringify(currentAddress));
        } else {
          localStorage.removeItem("citySetting");
          localStorage.removeItem("countrySetting");
          this.servicesService.updateCitySetting(null);
          this.helper.route.navigate(["/users/create-booking"]);
        }
      });
    }
  }

  /**
   * Clears the delivery address input field and resets the predictions array.
   */
  clearAddress(): void {
    this.deliveryAddressForm.patchValue({
      deliveryAddress: ""
    });
    this.destinationPredictions = [];
  }

  /**
   * Checks if the prediction is selected.
   * @param index The index of the prediction.
   * @returns True if the prediction is selected, false otherwise.
   */
  isSelected(index: number): boolean {
    return this.selectedSearchIndex === index;
  }

  removeBookingTime(event: Event): void {
    event.stopPropagation();
    localStorage.removeItem("bookingTime");
    this.bookingTime = 0;
  }

  /**
   * Handles date selection events.
   * @param event The selected date.
   */
  onDateSelected(event: any): void {
    localStorage.setItem("bookingTime", new Date(event).getTime().toString());
    this.bookingTime = `${this.datePipe.transform(event, "dd MMMM yyyy")}-${this.datePipe.transform(event, "hh:mm a")}`;
  }

  /**
   * Opens the cart modal if the cart is not empty.
   * If the route URL is /pages/services and the service main category allows service provider or company selection,
   * it opens the service provider modal instead.
   * @returns {void}
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  openCartModal(): void {
    if (this.totalCartItems > 0) {
      if (this.helper.route.url.includes("/users/create-booking/services")) {
        const serviceMainCategory: MainCategory =
          localStorage.getItem("cartServiceItemMainCategory") !== "undefined" ? JSON.parse(localStorage.getItem("cartServiceItemMainCategory") || "{}") : ({} as MainCategory);
        const cartItems: Cart[] = JSON.parse(localStorage.getItem("serviceCartItems") || "[]");
        const merchantProductInCart = cartItems.find((item) => item.serviceMerchantId !== undefined);
        if (
          !merchantProductInCart &&
          serviceMainCategory &&
          serviceMainCategory.serviceSetting &&
          (serviceMainCategory.serviceSetting.isAllowServiceProviderSelection || serviceMainCategory.serviceSetting.isAllowCompanySelection)
        ) {
          this.serviceProviderModal.openServiceProvidersModal(this.selectedBookingType);
        } else {
          this.cartModal.openCartModal();
        }
      } else if (this.helper.route.url.includes("/users/create-booking/e-delivery") || this.helper.route.url.includes("/users/create-booking/quick-commerce")) {
        this.cartModal.openCartModal();
      }
    }
  }

  /**
   * Sets the delivery address input field with the provided address.
   * Calls the checkBusiness function to update the business settings and
   * then patches the deliveryAddress form control with the address.
   * @param address The address object to set the delivery address to.
   */
  setAddress(address: any): void {
    this.checkBusiness(address);
    this.deliveryAddressForm.patchValue({
      deliveryAddress: address.address
    });
    // Open cart with new provider
    setTimeout(() => {
      this.cartModal.openCartModal(this.typeId, this.entityType, address);
    }, 500); // Small delay for smooth transition
  }

  /**
   * Handles the change service provider button click event from the cart modal.
   * Closes the cart modal and opens the service provider modal after a small delay for a smooth transition.
   * @param event The event object containing the change service provider button click event details.
   */
  onChangeServiceProvider(): void {
    // Close cart and open provider selection
    this.cartModal.closeModal();
    setTimeout(() => {
      this.serviceProviderModal.openServiceProvidersModal(this.selectedBookingType);
    }, 100);
  }

  /**
   * Handles the selection of a provider by closing any open modals and opening the cart modal with the selected provider's information.
   * Closes both the cart modal and the service provider modal to ensure no offcanvas elements are left open.
   * Opens the cart modal with the provided typeId and entityType after a small delay for a smooth transition.
   *
   * @param {Object} param0 - The provider selection details.
   * @param {string} param0.typeId - The ID of the selected provider type.
   * @param {number} param0.entityType - The entity type of the selected provider.
   */
  onSelectProvider({ typeId, entityType }: any): void {
    // Close any open offcanvas first
    this.cartModal.closeModal();
    this.serviceProviderModal.closeModal();
    this.typeId = typeId;
    this.entityType = entityType;
    // Open cart with new provider
    setTimeout(() => {
      this.cartModal.openCartModal(typeId, entityType);
    }, 100); // Small delay for smooth transition
  }

  openAddressModal(address?: any): void {
    if (this.totalCartItems > 0) {
      if (this.offcanvasService.hasOpenOffcanvas()) {
        this.cartModal.closeModal();
        setTimeout(() => {
          this.addressModal.openModal(address);
        }, 100);
      } else {
        this.addressModal.openModal();
      }
    }
  }
}
